/* eslint @typescript-eslint/camelcase: "off" */

import { API_URL } from '@constants';

import { getParametrizedUrl, getURIParams } from '@utils';

import { ApiError, IApiServerError } from '../../utils/ApiError';
import { BaseApi } from '../BaseApi';

import {
	ISubscriptionsApiPresentationAvailableCarouselRequestParams,
	ISubscriptionsApiPresentationAvailableCarouselResponseData,
	ISubscriptionsApiPresentationOrderDetailsRequestParams,
	ISubscriptionsApiPresentationOrderDetailsResponseData,
	ISubscriptionsApiSendCodeRequestParams,
	ISubscriptionsApiSendCodeResponseData,
	ISubscriptionsApiCreateRequestParams,
	ISubscriptionsApiCreateResponseData,
	ISubscriptionsApiProviderAvailableServicesRequestParams,
	ISubscriptionsApiProviderAvailableServicesResponseData,
} from './types';

export class SubscriptionsApi extends BaseApi {

	async fetchPresentationAvailableCarousel(params: ISubscriptionsApiPresentationAvailableCarouselRequestParams) {
		const {
			client_platform,
			mobile_operator_name,
			mobile_operator_mnc,
			deeplink_name,
			pkg_name,
		} = params;

		return this.get<ISubscriptionsApiPresentationAvailableCarouselRequestParams, ISubscriptionsApiPresentationAvailableCarouselResponseData>({
			url: getParametrizedUrl(API_URL.SUBSCRIPTIONS_PRESENTATION_AVAILABLE_CAROUSEL, {}, {
				client_platform,
				mobile_operator_name,
				mobile_operator_mnc,
				deeplink_name,
				pkg_name,
			}),
		});
	}

	async fetchPresentationOrderDetails(params: ISubscriptionsApiPresentationOrderDetailsRequestParams) {
		const { api_id, pkg_name } = params;

		return this.get<ISubscriptionsApiPresentationOrderDetailsRequestParams, ISubscriptionsApiPresentationOrderDetailsResponseData>({
			url: getParametrizedUrl(API_URL.SUBSCRIPTIONS_PRESENTATION_ORDER_DETAILS, {}, {
				api_id,
				pkg_name,
			}),
		});
	}

	async sendCode(provider: string, params: ISubscriptionsApiSendCodeRequestParams) {
		const url = getParametrizedUrl(API_URL.SUBSCRIPTIONS_PROVIDER_SEND_CODE, { provider });
		const response = await this.post<ISubscriptionsApiSendCodeRequestParams, ISubscriptionsApiSendCodeResponseData>({
			url,
			data: params,
		});

		if (response.status === 208) {
			throw new ApiError({
				serverError: response.data as unknown as IApiServerError,
				request: {
					url,
					method: 'POST',
					data: getURIParams(params),
				},
			});
		}

		return response;
	}

	async create(provider: string, params: ISubscriptionsApiCreateRequestParams) {
		return this.post<ISubscriptionsApiCreateRequestParams, ISubscriptionsApiCreateResponseData>({
			url: getParametrizedUrl(API_URL.SUBSCRIPTIONS_PROVIDER, { provider }),
			data: params,
		});
	}

	async fetchProviderAvailableServices(provider: string, params: ISubscriptionsApiProviderAvailableServicesRequestParams) {
		const { msisdn } = params;

		return this.get<ISubscriptionsApiProviderAvailableServicesRequestParams, ISubscriptionsApiProviderAvailableServicesResponseData>({
			url: getParametrizedUrl(API_URL.SUBSCRIPTIONS_PROVIDER_AVAILABLE_SERVICES, { provider }, {
				msisdn,
			}),
		});
	}

}
